import { BackgroundSQR } from '@ui/uikit/components/icons/poly';

import { useLastRoundInfo } from '../../../model/web3Raffle/api/useLastRoundInfo';
import raffleCardBgImage from './assets/raffle-card-bg.png';
import { CardButtons } from './buttons/CardButtons';

export const MagicRaffleCard = () => {
  const { data: roundInfo, isPending } = useLastRoundInfo();

  return (
    <div className="w-full relative max-w-full flex justify-center">
      <div
        className="
          absolute top-0 left-0 bottom-0 right-0
          bg-gradient-to-br from-[#FF8066] via-[#E566FF] to-[#66B2FF]
          blur-[83px] opacity-[0.08] rounded-full
        "
      />

      <div
        className="
          max-xs-msq:w-full
          border-2 border-base-border-pink-medium rounded-3xl
          bg-gradient-to-b from-[#FEF6FA] to-[#FFF]
          card-boxshadow-default
          p-4 pt-3
          flex flex-col gap-4
        "
        style={{
          backgroundImage: `url('${raffleCardBgImage.src}')`,
          backgroundSize: '100%',
          backgroundRepeat: 'no-repeat',
          zIndex: '1',
        }}
      >
        <div
          className="
          w-[300px] h-[236px]
          max-xl-msq:w-[288px] max-xl-msq:h-[236px]
          max-md-msq:w-[270px] max-md-msq:h-[142px]
          max-xs-msq:w-full max-xs-msq:h-[226]
          flex flex-col gap-4"
        >
          <div className="h-full flex items-end justify-center">
            <BackgroundSQR className="w-12 h-12" />
          </div>
          <div className="h-full flex items-start justify-center">
            <div className="flex flex-col items-center">
              <div className="text-base-text-tertiary text-caption-sm-a">Prize Pool</div>
              <div className="text-base-text-primary text-h1-a font-semibold flex gap-2 items-center">
                {isPending ? (
                  <span className="skeleton-text w-40 h-9 max-md-msq:w-30 max-md-msq:h-6 my-2" />
                ) : (
                  <span>{roundInfo?.prizePool.formatted} </span>
                )}
              </div>
              <div className="text-base-text-tertiary text-caption-sm-a">
                {isPending ? (
                  <span className="skeleton-text w-20 h-4 max-md-msq:w-15 max-md-msq:h-3" />
                ) : (
                  `~${roundInfo?.prizePoolUsdt.formatted}`
                )}
              </div>
            </div>
          </div>
        </div>
        <CardButtons roundId={roundInfo?.roundId} />
      </div>
    </div>
  );
};
